module.exports = __webpack_public_path__ + "static/media/_tibet.c7eb078a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/country-flags/_tibet.svg
// module id = 2356
// module chunks = 7